import React from "react";

const ErrorMessage = ({ errors }) => {
  return (
    errors &&
    errors.message && (
      <div className="v-text-field__details">
        <div className="v-messages theme--light error--text" role="alert">
          <div className="v-messages__wrapper">
            <div className="v-messages__message">{errors.message}</div>
          </div>
        </div>
      </div>
    )
  );
};

export default ErrorMessage;
